<template>
  <ion-page>
    <base-layout>
      <!-- <h3>Contact Us</h3> -->
      <div v-if="submitted === false">
        <ion-list style="padding-right: 20px"
          ><ion-item color="light">
            <ion-label><h1>Contact Us:</h1> </ion-label></ion-item
          >

          <ion-item>
            <input
              type="email"
              placeholder="Enter your email"
              class="input-one-contact-page"
              v-model="email"
            />
          </ion-item>

          <ion-item class="input-two-contact-page">
            <ion-textarea
              placeholder="How can we help?"
              v-model="inputData"
            ></ion-textarea>
          </ion-item>
          <div style="padding-left: 15px">
            <ion-button
              v-if="email && inputData"
              @click="submitForm"
              expand="block"
              >Submit</ion-button
            >
            <ion-button v-else :disabled="true" expand="block"
              >Submit</ion-button
            >
          </div>
          <ion-item v-if="error"> {{ error }} </ion-item></ion-list
        >
      </div>

      <div v-else class="submitted-contact-page">
        <div class="response-contact-page">
          <h3>Question submitted</h3>
          <p>
            We will reach out to you directly through the provided email
            address.
          </p>
          <p>Please allow up to 48 hours before reaching out again.</p>
        </div>
      </div>
    </base-layout></ion-page
  >
</template>

<script>
// import { useRouter } from "vue-router";
import { ref, watch } from "vue";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase/config";
import {
  // modalController,
  // IonInput,
  IonLabel,
  IonButton,
  // IonItem,
  IonList,
  // loadingController,
  IonItem,
  IonTextarea,
  IonPage,
} from "@ionic/vue";
import { useActiveMeta } from "vue-meta";
import { typAsync } from "../composables/typAsync.js";
export default {
  components: {
    // IonInput,
    IonLabel,
    IonButton,
    // IonItem,
    IonList,
    IonItem,
    IonTextarea,
    IonPage,
  },

  setup() {
    //start meta data
    let metadata = useActiveMeta();
    const changeMetaHolder = ref(false);
    useCurrentMetaData();

    function changeMeta() {
      changeMetaHolder.value = true;
    }

    watch(changeMetaHolder, (newValue) => {
      if (newValue === true) {
        useCurrentMetaData();
        changeMetaHolder.value = false;
      }
    });

    function useCurrentMetaData() {
      metadata.title = "Contact Us"; //60 character max
      metadata.description = "Use this page to contact Knock Stoppers";
    }
    // end meta data

    const error = ref("");
    const email = ref("");
    const inputData = ref("");

    const submitted = ref(false);

    //submit form and push to dashboard
    function submitForm() {
      return typAsync(async () => {
        if (email.value) {
          if (inputData.value) {
            const colRef = collection(db, "questions");

            await addDoc(colRef, {
              site: "Knock Stoppers",
              email: email.value,
              userInput: inputData.value,
              date: `${new Date()}`,
            });

            email.value = "";
            inputData.value = "";
          } else {
            error.value = "enter text";
          }
        } else {
          error.value = "enter valid email";
        }

        submitted.value = true;
      });
    }

    return { error, email, inputData, submitForm, submitted, changeMeta };
  },
};
</script>

<style>
.form-create-addresses-page {
  padding: 10px;
  margin-top: 10px;
  /* border: 1px dashed #c3c8ce; */
}

.input-one-contact-page {
  background-color: transparent;
  border: none;
  width: 90%;
  overflow-x: scroll;
}

.input-two-contact-page {
  /* background-color: transparent; */
  /* border: none; */
  /* width: 90%; */
  /* height: 50%; */
  /* overflow: scroll; */
  height: 100px;
}

.submitted-contact-page {
  height: 100%;
  width: 100%;
}

.response-contact-page {
  padding: 15px 15px;
}
</style>
